<mat-form-field appearance="outline" color="primary">
  <mat-label i18n="@@core.filter.buffer-in-meters">Buffer in meters</mat-label>
  <input matInput type="number" [formControl]="bufferControl">
</mat-form-field>
